import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase as SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';


@Component({
    selector: 'app-measure-heartrate-item',
    templateUrl: './measure-heartrate-item.component.html',
    styleUrl: './measure-heartrate-item.component.scss',
    imports: [ItemContentComponent,],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeartRateItemComponent implements SheetItemComponentBase {

	@Input() row!: Row;
    @Input() startLabel!: string;
    @Input() endLabel!: string;

	constructor() {
	}
}